import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { Reservation } from './types';

type Variables = {};
type Response = Reservation[];

export const useReservationsInCollection = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['reservations/collections'],
  fetcher: () => {
    return client.get(`v2/reservations/collections`).then((response) => {
      return response.data.data;
    });
  },
});
